<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<mat-icon color="accent" mat-ripple class="circle-icon-remove" svgIcon="md:remove"	(click)="removeValue(idx)"></mat-icon>
		<copo-loading-spinner class="loading-spinner" *ngIf="isLoading"></copo-loading-spinner>
		<ng-container *ngIf="!isLoading">
			<mat-form-field appearance="outline" subscriptSizing="dynamic" class="copo-no-error-message">
				<mat-select *ngIf="!showDropdown" [placeholder]="filter.placeholder" (selectionChange)="filter.getValues()[idx] = $event.value" [(value)]="filter.getValues()[idx]" [compareWith]="compareItems">
					<mat-option *ngFor="let filterItem of filteredItems" [value]="filterItem">
						{{ filterItem.translation }}
					</mat-option>
				</mat-select>
				<mat-select *ngIf="showDropdown" [placeholder]="filter.placeholder" (selectionChange)="filter.getValues()[idx] = $event.value" [(value)]="filter.getValues()[idx]" [compareWith]="compareItems">
					<mat-option *ngFor="let filterItem of filteredItems" [value]="filterItem">
						{{ filterItem.translation }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</ng-container>
	</div>
</ng-container>
